//src/lib/registerClipView.js 

import api from "../api";

const viewedThisSession = new Set();

export function registerClipView(video, clipId, onCounted) {
  if (!video || !clipId) return () => {};

  let counted = false;

  const checkView = async () => {
    if (counted) return;

    if (!video.duration || isNaN(video.duration)) return;

    const watchedPercent = video.currentTime / video.duration;

    const watchedEnough =
      watchedPercent >= 0.7 ||
      video.currentTime >= 10;

    if (!watchedEnough) return;

    counted = true;

    if (viewedThisSession.has(clipId)) return;

    viewedThisSession.add(clipId);

    try {
      const { data } = await api.post(`/posts/${clipId}/view`);

      if (typeof data.view_count === "number") {
        onCounted?.(data.view_count);
      }
    } catch (err) {
      console.error("view failed", err);
    }

    video.removeEventListener("timeupdate", checkView);
  };

  video.addEventListener("timeupdate", checkView);

  return () => {
    video.removeEventListener("timeupdate", checkView);
  };
}